import { Skeleton } from "ui";

export function SectionEditSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="shrink-0 border-b px-4 pt-2 pb-1">
        <Skeleton className="h-9 w-48" />
      </div>
      <div className="flex min-h-0 flex-1 flex-col lg:flex-row">
        <div className="flex-1 space-y-3 px-5 py-4 lg:pl-10">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="h-8 w-1/2" />
          <Skeleton className="h-8 w-2/3" />
        </div>
        <div className="w-full shrink-0 space-y-2 bg-background p-2 lg:max-w-[250px] lg:border-l">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    </div>
  );
}
